
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_callback",
      function () {
        return require("private-next-pages/_callback.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_callback"])
      });
    }
  